import api from "./api"

/**
 * Dosyayı presigned R2 akışıyla yükler ve `File.id` döndürür.
 *
 * İki adım: (1) sunucudan imzalı PUT adresi al, (2) baytları doğrudan R2'ye
 * gönder, (3) meta kaydını oluştur. Baytlar hiçbir zaman backend'den geçmez.
 * (`uploadAvatarFile` ile aynı desen; burası genel amaçlı hâli.)
 */
export async function uploadFile(file: File): Promise<string> {
  const mimeType = file.type || "application/octet-stream"

  const { data: up } = await api.post<{
    uploadUrl: string
    path: string
    fileId: string
  }>("/files/upload-url", { filename: file.name, mimeType })

  const res = await fetch(up.uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": mimeType },
    body: file,
  })
  if (!res.ok) {
    throw new Error("Dosya yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.")
  }

  await api.post("/files", {
    fileId: up.fileId,
    filename: file.name,
    path: up.path,
    mimeType,
    size: file.size,
  })

  return up.fileId
}

/**
 * Form şablonu PDF'ini yükler.
 *
 * Şablonlar **değiştirilmez**: aynı belgeyi yeniden yüklemek yeni bir `File`
 * kaydı üretir. Böylece yayınlanmış içerik tipi sürümlerinin dondurduğu
 * yerleşim her zaman kendi belgesini gösterir.
 */
export async function uploadTemplateFile(file: File): Promise<string> {
  if (file.type !== "application/pdf" && !/\.pdf$/i.test(file.name)) {
    throw new Error("Şablon olarak yalnız PDF yüklenebilir.")
  }
  return uploadFile(file)
}
